import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-recommend",
  "use": "icon-recommend-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-recommend\"><path d=\"M454.542222 782.791111L261.688889 1024l-100.693333-140.856889L0 833.479111l185.457778-272.099555zM570.709333 786.318222L761.856 1024l99.783111-140.856889L1024 834.332444l-164.977778-243.825777zM511.317333 0a434.403556 434.403556 0 1 1 0 868.807111A434.403556 434.403556 0 0 1 511.317333 0z m0 271.530667a162.929778 162.929778 0 1 0 0 325.802666 162.929778 162.929778 0 0 0 0-325.802666z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/recommend.svg
// module id = rtce
// module chunks = 78